/**
 * Whether MUI date pickers should block future dates for a structure field.
 * Default: block future dates unless allowFutureDates is explicitly true.
 * @param {{ type?: string, allowFutureDates?: boolean } | null | undefined} element
 */
export function shouldDisableFutureDates(element) {
  if (!element || (element.type !== 'date' && element.type !== 'datetime')) {
    return true
  }
  return !element.allowFutureDates
}
